import { useEntryPriceAfterSpread } from '@ui/features/Trade/hooks/useEntryPriceAfterSpread';
import { useFromInput } from '@ui/features/Trade/hooks/useFromInput';
import { usePayTokenPriceLatest } from '@ui/features/Trade/hooks/usePayTokenPriceLatest';
import { PricesFactor } from '@ui/features/Trade/types';
import { useIsNeedTokenApproval } from '@ui/hooks/useErc20Read';
import { useGasFee } from '@ui/hooks/useGasFee';
import { useEstimateOpenPositionGasLimit } from '@ui/services/contract/hooks/TradingPortalFacet/useEstimateOpenPositionGasLimit';
import { OrderType } from '@ui/types/trade';
import BigNumber from 'bignumber.js';
import { useEffect, useState } from 'react';

import { useOpenMarketTradeParams } from '../../TradeModuleConfirm/hooks/useOpenMarketTradeParams';
import { useCollateralToken } from '../store/useCollateralToken';
import { useOrderType } from '../store/useOrderType';

/**
 *
 * Gas calculation
 *
 * estimateGasLimit : TradingPortalFacet.estimateGas.openMarketTrade
 *
 * gasPrice * estimateGasLimit = estFeeInNativeTokenAmount
 *
 * estFeeInUsd = estFeeInNativeTokenAmount * nativeTokenPrice
 *
 */
// native token
export const useCalcEstOpenPositionGasFee = () => {
  const inputAmount = useFromInput((s) => s.input).value.token;
  const payToken = useCollateralToken((s) => s.useCollateralTokenValue());
  const entryPrice = useEntryPriceAfterSpread();
  const payTokenPrice = usePayTokenPriceLatest(payToken);
  const isNeedTokenApproval = useIsNeedTokenApproval({
    tokenAddress: payToken?.address,
    requiredAmount: inputAmount,
  });

  const openMarketTradeParams = useOpenMarketTradeParams();

  const orderType = useOrderType((s) => s._persistValue);
  const isMarket = orderType === OrderType.MARKET;

  const { data: estimateOpenPositionGasLimit, refetch } =
    useEstimateOpenPositionGasLimit({
      openMarketTradeParams,
      opts: {
        enabled:
          isMarket &&
          !!entryPrice &&
          !!payTokenPrice &&
          !!openMarketTradeParams &&
          !!isNeedTokenApproval &&
          !isNeedTokenApproval.data, // only fetch when the token is approved
      },
    });

  useEffect(() => {
    const h = setTimeout(() => {
      if (isMarket) {
        refetch();
      }
    }, 100);
    
return () => clearTimeout(h);
  }, [inputAmount]);

  const { data: gas } = useGasFee(estimateOpenPositionGasLimit);
  
return {
    gas: gas,
    refetch,
  };
};
